<template>
    <div>
        <CargandoInfo :mostrarCarga="cargandoInfo" :height="20" :mensajeInfo="'Obteniendo información General'" />
        <CCardGroup v-show="!cargandoInfo" class="mb-4 tarjetaTotales">
            <CWidgetProgress color="info" v-if="mostrarClientes"
                :content="'Información General Clientes'"                                            
                v-tippy="{ 
                    placement: 'top',
                    arrow: true, 
                    arrowType: 'round', 
                    animation:'fade',
                    theme: 'google',
                    followCursor : true
                }">
                <CRow>
                    <CCol>
                        <div class="m-0 text-center font-weight-bold textosTotales">{{$utils.validarNegativos(datosGeneral.total, false)}}</div>
                        <div class="text-center text-muted">Total</div>
                    </CCol>
                    <CCol>
                        <div class="m-0 text-center font-weight-bold textosTotales">{{$utils.validarNegativos(datosGeneral.totalHabilitados, false)}}</div>
                        <div class="text-center text-muted">Habilitados</div>
                    </CCol>
                    <CCol>
                        <div class="m-0 text-center font-weight-bold textosTotales">{{$utils.validarNegativos(datosGeneral.totalNoHabilitados, false)}}</div>
                        <div class="text-center text-muted">No Hab.</div>
                    </CCol>
                </CRow>
            </CWidgetProgress>

            <CWidgetProgress color="info" v-if="mostrarUsuarios">
                <div class="text-center text-muted mb-2">Usuarios</div>
                <CRow>
                    <CCol>
                        <div class="m-0 text-center font-weight-bold textosTotales">{{datosGeneral.infoUsuarios.totalUsuarios}}</div>
                        <div class="text-center text-muted">Total</div>
                    </CCol>
                    <CCol>
                        <div class="m-0 text-center font-weight-bold textosTotales">{{datosGeneral.infoUsuarios.habilitados}}</div>
                        <div class="text-center text-muted">Habilitados</div>
                    </CCol>
                    <CCol>
                        <div class="m-0 text-center font-weight-bold textosTotales">{{datosGeneral.infoUsuarios.deshabilitados}}</div>
                        <div class="text-center text-muted">No Hab.</div>
                    </CCol>
                </CRow>
                
            </CWidgetProgress>

            <CWidgetProgress color="info" v-if="mostrarApps">
                <div class="text-center text-muted mb-2">Apps</div>
                <CRow>
                <CCol>
                    <div class="m-0 text-center font-weight-bold textosTotales">{{datosGeneral.infoApps.totalApps}}</div>
                    <div class="text-center text-muted">Total</div>
                </CCol>
                <CCol>
                    <div class="m-0 text-center font-weight-bold textosTotales">{{datosGeneral.infoApps.asignadas}}</div>
                    <div class="text-center text-muted">Asignadas</div>
                </CCol>
                <CCol>
                    <div class="m-0 text-center font-weight-bold textosTotales">{{(datosGeneral.infoApps.totalApps-datosGeneral.infoApps.asignadas)}}</div>
                    <div class="text-center text-muted">Sin Asignar</div>
                </CCol>
                
                </CRow>
            </CWidgetProgress>
        </CCardGroup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";

    import { freeSet } from "@coreui/icons";

    export default {
        name: "DatosGeneralClientes",
        freeSet,
        props: {
            datosGeneral: Object,
            mostrarClientes: Boolean,
            mostrarUsuarios: Boolean,
            mostrarApps: Boolean,
            cargandoInfo: Boolean,
        },
        components: {
        },
        data() {
            return {

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,
                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                
            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {

        },
    };
</script>

<style>
</style>